module.exports = __webpack_public_path__ + "static/media/background-lobby-623.9a51649e.png";